module.exports = __webpack_public_path__ + "media/images/menu/volans-2fd1dddd058e207ad52c75c2d141dc56.jpg";